import { render } from "./SelectEditInput.vue?vue&type=template&id=702f1fbc"
import script from "./SelectEditInput.vue?vue&type=script&lang=js"
export * from "./SelectEditInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/helpdesk.moov-africa.bj/releases/81254874/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__